
//@ts-ignore
import {Component, Prop, VModel, Vue} from "vue-property-decorator";
import BaseInput from "./Form/BaseInput.vue";
import ListInput from "./Form/ListInput.vue";
import TextInput from "./Form/TextInput.vue";
import SecretInput from "./Form/SecretInput.vue";
import StatusInput from "./Form/StatusInput.vue";
import BoolInput from "./Form/BoolInput.vue";
import SelectInput from "./Form/SelectInput.vue";
import NumberInput from "./Form/NumberInput.vue";
import EmailInput from "./Form/EmailInput.vue";
import HtmlInput from "./Form/HtmlInput.vue";
import MultiSelectInput from "./Form/MultiSelectInput.vue";
import DateInput from "./Form/DateInput.vue";
import TimeInput from "./Form/TimeInput.vue";
import SliderInput from "./Form/SliderInput.vue";

@Component({
    name: 'FieldContainer',
    components: {
        SliderInput,
        TimeInput,
        DateInput,
        MultiSelectInput,
        HtmlInput,
        EmailInput,
        NumberInput,
        SelectInput,
        BoolInput,
        StatusInput,
        SecretInput,
        TextInput,
        ListInput,
        FieldContainer,
        BaseInput
    },
})
export default class FieldContainer extends Vue {
    @VModel({
        default: () => {
        }
    })
    public item: any; //field obj
    public inputNameRepeatBlock: string = '';

    @Prop()
    public success!: object[];

    @Prop()
    public error!: object[];

    @Prop({default: false})
    public depth!: number;

    // mounted() {
    //     this.path = this.generatePath(this.item.name, this.item.path);
    //     console.log('this is the mounted of: ' + this.path)
    // }
    //
    // unmounted() {
    //     console.log('unmounting ' + this.item.name)
    // }


    calculateDepth(passedDepth: number): number {
        //start high and progressively get lower
        let top = 28;
        let result: number;
        result = top - (passedDepth * 2.5);

        return result;
    }

    generatePath(name: string, path: string): string {
        let newPath: string;
        newPath = path ? path + '.' + name : name;

        return newPath;
    }

    addChildToChildren(repeatChild: object) {
        //check if child already exists
        if (Object.keys(this.item.children).includes(this.inputNameRepeatBlock)) {
            return alert('Name already exists in current container')
        }

        //clone repeat block
        let clone = Object.assign({}, repeatChild)

        //reset values
        clone = this.changeValuesOfChildren(clone);

        //add new object/ child to container. (Creating new container to update reactivity)
        this.item.children = Object.assign({}, {
            [clone.name]: clone,                                                                              //https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
        }, this.item.children)  //new item above older items to it doesn't fall behind v-text-field

        console.log('child with name: ' + this.inputNameRepeatBlock + ' has been added to the current container')
    }

    changeValuesOfChildren(item: object) {
        //strip the repeat of the name(s) and path
        let name: string;
        let path: string;

        //change the name of field
        name = item.name.replaceAll('repeat', this.inputNameRepeatBlock);
        item.name = name;

        //change the path of the field
        path = item.path.replaceAll('repeat', this.inputNameRepeatBlock) || item.path + '.' + this.inputNameRepeatBlock;
        item.path = path;


        //reset value
        item.value = null;

        //check if children exist, if so do the same foreach child
        if (this.itemHasChildren(item)) {
            Object.keys(item.children).forEach((childName) => {
                item.children[childName] = this.changeValuesOfChildren(item.children[childName])
            })
        }

        return item;
    }

    private itemHasChildren(child): boolean {
        return Object.keys(child.children).length > 0 || child.children.length > 0;
    }


}
